import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=ce5036b8&scoped=true"
import script from "./Result.vue?vue&type=script&lang=ts"
export * from "./Result.vue?vue&type=script&lang=ts"
import style0 from "./Result.vue?vue&type=style&index=0&id=ce5036b8&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5036b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src400484917/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce5036b8')) {
      api.createRecord('ce5036b8', component.options)
    } else {
      api.reload('ce5036b8', component.options)
    }
    module.hot.accept("./Result.vue?vue&type=template&id=ce5036b8&scoped=true", function () {
      api.rerender('ce5036b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/search/Result.vue"
export default component.exports